module.exports = __webpack_public_path__ + "static/docusaurus-f3097820144b7c8c07f7c2361badeeb5.svg";